import React, { FC, useEffect } from 'react';
import { analytics } from '../../lib/analytics';

// this is shown for mobile
// https://github.com/tidalmarket/api/blob/52827388e2030d587379f9004938d4e24e1f5246/apps/rentals/src/orders/orders.service.ts#L838
const Checkout: FC<{}> = () => {
  useEffect(() => {
    analytics.page(`Rental Completed Order - Mobile`);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <h1>Order Checkout Successful</h1>
    </div>
  );
};

export default Checkout;
